/* unplugin-vue-components disabled */import script from "./cheatDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./cheatDialog.vue?vue&type=script&lang=ts&setup=true"

import "./cheatDialog.vue?vue&type=style&index=0&id=041d6cb5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041d6cb5"]])

export default __exports__